import Storage from './index';

class CacheStorage extends Storage {
  constructor() {
    super('Cache');
  }
}

export default new CacheStorage();
